import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MessageCircle } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { COLORS, SITE_CONFIG, SOCIAL_LINKS } from "../../../Utiles/Constants";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const footerLinks = {
    product: [
      { name: "Features", href: "#features" },
      { name: "How It Works", href: "#how-it-works" },
      { name: "Pricing", href: "#pricing" },
      { name: "FAQ", href: "#faq" },
    ],
    company: [
      { name: "About Us", href: "/about-us" },
      { name: "Blog", href: "/blog" },
      // { name: "Careers", href: "#" },
      // { name: "Contact", href: "/contact" },
    ],
    resources: [
      { name: "Help Center", href: "/help-center" },
      { name: "WhatsApp Guidelines", href: "/whatsapp-guidelines" },
      { name: "Privacy Policy", href: "/privacy-policy" },
      { name: "Terms of Service", href: "/terms-conditions" },
    ],
  };
  
  const handleScrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  const handleProductClick = (id) => {
    if (location.pathname === "/") {
      // Already on home → scroll directly
      handleScrollTo(id);
    } else {
      // Go home first, then scroll
      navigate("/", { state: { scrollTo: id } });
    }
  };
  return (
    <footer
      style={{
        backgroundColor: "#0f172a",
        color: "#cbd5e1",
        borderTop: "1px solid #1e293b",
      }}
    >
      <Container>
        <div style={{ padding: "80px 0 40px" }}>
          <Row className="g-5">
            {/* Brand */}
            <Col lg={4} md={6}>
              <Link
                to="/"
                className="d-flex align-items-center mb-4 text-decoration-none"
                style={{
                  transition: "transform 0.2s ease",
                }}
                onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
              >
                <MessageCircle
                  className="me-2"
                  size={36}
                  style={{ color: COLORS.success }}
                />
                <span
                  style={{
                    fontSize: "1.4rem",
                    fontWeight: "800",
                    color: "white",
                    letterSpacing: "-0.5px",
                  }}
                >
                  {SITE_CONFIG.name}
                </span>
              </Link>

              <p
                style={{
                  color: "#94a3b8",
                  lineHeight: "1.7",
                  fontSize: "1rem",
                  marginBottom: "32px",
                }}
              >
                Automate WhatsApp for your business. Send campaigns, manage
                contacts, and track results with our powerful platform.
              </p>

              <div className="d-flex gap-3">
                {SOCIAL_LINKS.map(({ icon: Icon, href, label }) => (
                  <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    style={{
                      color: "#64748b",
                      padding: "8px",
                      borderRadius: "8px",
                      backgroundColor: "#1e293b",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "all 0.3s ease",
                      textDecoration: "none",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = COLORS.primary;
                      e.target.style.backgroundColor = "#334155";
                      e.target.style.transform = "translateY(-2px)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = "#64748b";
                      e.target.style.backgroundColor = "#1e293b";
                      e.target.style.transform = "translateY(0)";
                    }}
                  >
                    <Icon size={20} />
                  </a>
                ))}
              </div>
            </Col>
            {Object.entries(footerLinks).map(([title, links]) => (
              <Col key={title} xs={6} md={2} lg={2}>
                <h5
                  style={{
                    color: "white",
                    fontWeight: "700",
                    fontSize: "1.1rem",
                    marginBottom: "24px",
                    textTransform: "capitalize",
                  }}
                >
                  {title}
                </h5>
                <ul className="list-unstyled">
                  {links.map((link) => (
                    <li key={link.name} style={{ marginBottom: "12px" }}>
                      {title === "product" ? (
                        <button
                          onClick={() =>
                            handleProductClick(link.href.replace("#", ""))
                          }
                          style={{
                            background: "none",
                            border: "none",
                            padding: 0,
                            cursor: "pointer",
                            color: "#94a3b8",
                            fontSize: "0.95rem",
                            textAlign: "left",
                            transition: "all 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = "white";
                            e.target.style.transform = "translateX(4px)";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = "#94a3b8";
                            e.target.style.transform = "translateX(0)";
                          }}
                        >
                          {link.name}
                        </button>
                      ) : (
                        <Link
                          to={link.href}
                          style={{
                            color: "#94a3b8",
                            textDecoration: "none",
                            fontSize: "0.95rem",
                            transition: "all 0.2s ease",
                            display: "inline-block",
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.color = "white";
                            e.target.style.transform = "translateX(4px)";
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.color = "#94a3b8";
                            e.target.style.transform = "translateX(0)";
                          }}
                        >
                          {link.name}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </Col>
            ))}
          </Row>

          <div
            className="d-flex justify-content-between align-items-center flex-wrap gap-3 mt-5 pt-4"
            style={{
              borderTop: "1px solid #1e293b",
              marginTop: "60px !important",
            }}
          >
            <p
              style={{
                fontSize: "0.9rem",
                color: "#64748b",
                margin: "0",
                fontWeight: "500",
              }}
            >
              © 2025 {SITE_CONFIG.name}. All rights reserved.
            </p>

            <div className="d-flex gap-4 flex-wrap">
              {[
                { name: "Terms of Service", href: "/terms-conditions" },
                { name: "Privacy Policy", href: "/privacy-policy" },
              ].map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  rel="noopener noreferrer"
                  style={{
                    color: "#64748b",
                    fontSize: "0.9rem",
                    textDecoration: "none",
                    fontWeight: "500",
                    transition: "color 0.2s ease",
                  }}
                  onMouseEnter={(e) => (e.target.style.color = "white")}
                  onMouseLeave={(e) => (e.target.style.color = "#64748b")}
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
